import {Component, input, output} from '@angular/core';
import {Card} from 'primeng/card';
import {Button} from 'primeng/button';
import {IconLogin} from '@components/icons/icon-login/icon-login';
import {NgOptimizedImage} from '@angular/common';
import {ProgressSpinner} from 'primeng/progressspinner';

@Component({
  selector: 'app-auth-card',
  imports: [
    Card,
    Button,
    IconLogin,
    NgOptimizedImage,
    ProgressSpinner
  ],
  templateUrl: './auth-card.html',
  styleUrl: './auth-card.css'
})
export class AuthCard {

  message = input<string>("")
  loadingVisibility = input<boolean>(false);
  buttonAcessarVisibility= input<boolean>(true);
  buttonVisitanteVisibility = input<boolean>(false);

  acessar = output<void>();
  visitante = output<void>();

  onAcessar() {
    this.acessar.emit();
  }

  onVisitante() {
    this.visitante.emit();
  }
}
